import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@gonka-wallet/ui-tokens';
import { useActiveEntry } from '../stores/walletStore.js';
import { useToastStore } from '../stores/toastStore.js';
import { QRCode } from '../components/QRCode.js';
import { BackLink } from '../components/BackLink.js';

export function Receive() {
  const { t } = useTranslation();
  const active = useActiveEntry();
  const pushToast = useToastStore((s) => s.push);
  const [copied, setCopied] = useState(false);

  const address =
    active?.kind === 'full'
      ? active.wallet.addresses[0]
      : active?.kind === 'watch'
        ? active.watched.address
        : null;
  const name =
    active?.kind === 'full'
      ? active.wallet.name
      : active?.kind === 'watch'
        ? active.watched.name
        : null;
  const isWatch = active?.kind === 'watch';

  if (!address) {
    return (
      <div className="flex min-h-screen items-center justify-center p-6">
        <p className="text-text-secondary">{t('receive.noWallet')}</p>
      </div>
    );
  }

  async function onCopy() {
    if (!address) return;
    try {
      await navigator.clipboard.writeText(address);
    } catch {
      pushToast(t('common.copyFailed'), 'error');
      return;
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 1400);
  }

  return (
    <div className="flex min-h-screen flex-col bg-bg text-text-primary">
      <div className="flex items-center px-4 pb-2 pt-4">
        <BackLink to="/wallet" label={t('common.back')} />
      </div>

      <div className="flex flex-1 flex-col items-center gap-6 px-4 pb-8 pt-4">
        <div className="flex flex-col items-center gap-1">
          <span className="text-[10px] font-semibold uppercase tracking-[1.4px] text-text-tertiary">
            {t('receive.title')}
          </span>
          {name && (
            <span className="flex items-center gap-2 text-[15px] font-semibold text-text-primary">
              {name}
              {isWatch && (
                <span className="inline-flex items-center gap-1 rounded-full bg-surface-2 px-2 py-0.5 text-[9px] font-semibold uppercase tracking-[0.5px] text-link">
                  <span aria-hidden className="h-1 w-1 rounded-[1px] bg-current" />
                  {t('watchedAddress.watchBadge')}
                </span>
              )}
            </span>
          )}
        </div>

        <div className="rounded-[18px] bg-white p-4 shadow-[0_2px_14px_rgba(0,0,0,0.04)]">
          <QRCode value={address} />
        </div>

        <div className="w-full rounded-xl bg-surface-1 px-4 py-3.5">
          <div className="mb-1 text-[10px] font-semibold uppercase tracking-[1.4px] text-text-tertiary">
            {t('receive.yourAddress')}
          </div>
          <div className="break-all font-mono text-[11px] leading-relaxed text-text-primary">
            {address}
          </div>
        </div>

        <Button
          variant={copied ? 'secondary' : 'primary'}
          onClick={onCopy}
          disabled={copied}
          fullWidth
        >
          {copied ? `✓ ${t('common.copied')}` : t('home.copyAddress')}
        </Button>

        <p className="mt-auto text-center text-[11px] leading-relaxed text-text-tertiary">
          {t('receive.scanQr')}
        </p>
      </div>
    </div>
  );
}
